module.exports = __webpack_public_path__ + "Roboto-Thin.90d3804f0231704c15cc.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.woff
// module chunks = 5